export enum TipoImposto {
  DARF = "DARF",
  GPS = "GPS",
  OUTROS_IMPOSTOS = "OUTROS_IMPOSTOS",
}

export const getTipoSacadoFormatado = (tipoImposto: TipoImposto) => {
  switch (tipoImposto) {
    case TipoImposto.DARF:
      return "DARF";
    case TipoImposto.GPS:
      return "GPS";
    case TipoImposto.OUTROS_IMPOSTOS:
      return "Outros Impostos";
  }
};
